import { useCallback, useState } from 'react'

export type ArticleHistory = {
  currentArticleId?: string
  currentPath?: string;
  navigate: (articleId?: string, path?: string) => void;
  goBack: () => void;
  goForward: () => void;
  canGoBack: boolean;
  canGoForward: boolean;
}

export type ArticleHistoryEntry = {
  articleId?: string
  path?: string
}

const useArticleHistory = (initialPath: string) => {

  const [history, setHistory] = useState<ArticleHistoryEntry[]>([{path: initialPath}]);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Method to navigate to a new path
  const navigate = useCallback((articleId?: string, path?: string) => {
    setHistory((prevHistory) => {
      const updatedHistory = prevHistory.slice(0, currentIndex + 1);
      updatedHistory.push({articleId, path});
      return updatedHistory;
    });
    setCurrentIndex((prevIndex) => prevIndex + 1);

  }, [currentIndex]);

  // Method to go backward in history
  const goBack = useCallback(() => {
    if (currentIndex > 0) {
      setCurrentIndex((prevIndex) => prevIndex - 1);
    }
  }, [currentIndex]);

  // Method to go forward in history
  const goForward = useCallback(() => {
    if (currentIndex < history.length - 1) {
      setCurrentIndex((prevIndex) => prevIndex + 1);
    }
  }, [currentIndex, history.length]);

  const current = history[currentIndex]
  const currentArticleId = current.articleId
  
  // Get the current path
  const currentPath = current.path;

  return {
      currentArticleId,
      currentPath,
      navigate,
      goBack,
      goForward,
      canGoBack: currentIndex > 0,
      canGoForward: currentIndex < history.length - 1,
  };
}

export default useArticleHistory